import { usePartner } from 'components/app/routes/usePartner';
import { LOGIN_REQUIRED } from 'config/app-config';

type UseIsLoginEnabledJourneyProps = {
  exclude?: string[];
};
export const useIsLoginEnabledJourney = ({
  exclude = []
}: UseIsLoginEnabledJourneyProps = {}) => {
  const { partnerName } = usePartner();
  const loginEnabledJourneys = Object.entries(LOGIN_REQUIRED)
    .filter(([path, requiresLogin]) => requiresLogin && !exclude.includes(path))
    .map(([path]) => path);

  return partnerName ? loginEnabledJourneys.includes(partnerName) : false;
};
